/** Screen 2 — "What will the widget diagnose": trades, service area, capture modes. */
import { useDraftContinue } from '../config/draft';
import { PublishBar } from '../config/PublishBar';
import { CaptureModes, ServiceAreaEditor, TradesPicker } from '../config/sections/ScopeSection';
import { WithSiteDraft } from '../config/WithSiteDraft';
import { OnboardingPage } from '../setup/OnboardingPage';
import { SetupPathChooser } from '../agent/SetupPath';
import { useSites } from '../state/sites';

function Body() {
  const footer = useDraftContinue();
  const { current } = useSites();
  return (
    <OnboardingPage
      slug="trades"
      lede="Pick the trades you handle and where. Problems outside them still get a diagnosis, then the out-of-scope behaviour you choose."
      {...footer}
    >
      {/* The first screen a new partner sees: both ways to set up, side by side
          (migration 070). The manual path is the default and stays one click away. */}
      <SetupPathChooser
        manualDescription="Answer each question in the portal and paste the snippet yourself. About 15 minutes."
        manual={
          <>
            <section className="panel panel-pad stack">
              <TradesPicker />
            </section>
            <section className="panel panel-pad">
              <ServiceAreaEditor />
            </section>
            <section className="panel panel-pad">
              <CaptureModes />
            </section>
            <PublishBar hasTestKey={Boolean(current?.test)} />
          </>
        }
      />
    </OnboardingPage>
  );
}

export function TradesArea() {
  return (
    <WithSiteDraft>
      <Body />
    </WithSiteDraft>
  );
}
